import { ComponentProps, PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type ListProps = ComponentProps<'div'>

export const List = ({
  className,
  children,
  ...restProps
}: PropsWithChildren<ListProps>) => {
  return (
    <div
      role="tablist"
      className={cn(
        'border-gray-0 flex h-11 overflow-x-auto border-b bg-white',
        'before:absolute before:bottom-0 before:-left-2 before:h-full before:w-2 before:bg-white before:content-[""]',
        'after:absolute after:-right-2 after:bottom-0 after:h-full after:w-2 after:bg-white after:content-[""]',
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  )
}

type ItemProps = ComponentProps<'button'> & {
  selected: boolean
}

export const Item = ({
  selected,
  className,
  children,
  ...restProps
}: PropsWithChildren<ItemProps>) => {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      className={cn(
        'typo-body2 relative px-4 pt-2.5 pb-3 font-medium text-gray-200',
        'shrink-0 cursor-pointer transition-colors',
        'first:pl-0',
        'focus-visible:rounded-sm focus-visible:ring-2 focus-visible:ring-gray-100',
        {
          'font-bold text-black before:absolute before:bottom-0 before:left-0 before:h-0.5 before:w-full before:bg-black before:content-[""]':
            selected,
        },
        className,
      )}
      {...restProps}
    >
      {children}
    </button>
  )
}
